(() => {
 if (window.gnomeCatalogReady) return;
 window.gnomeCatalogReady = true;
 let controller;
 async function navigate(url, push = true) {
  let catalog = document.querySelector('[data-gn-catalog]');
  if (!catalog) { location.assign(url); return; }
  controller?.abort();
  const request = new AbortController();
  controller = request;
  catalog.setAttribute('aria-busy', 'true');
  const target = new URL(url, location.href);
  const fetchUrl = new URL(target);
  if (fetchUrl.pathname === '/') fetchUrl.pathname = '/collections/all';
  fetchUrl.searchParams.set('section_id', 'gnome-catalog');
  try {
   const response = await fetch(fetchUrl, {signal: request.signal});
   if (!response.ok) throw new Error('Catalog unavailable');
   const html = new DOMParser().parseFromString(await response.text(), 'text/html');
   const next = html.querySelector('[data-gn-catalog]');
   if (!next) throw new Error('Catalog missing');
   catalog.replaceWith(next);
   const heading = document.querySelector("[data-gn-collection-title]");
   if (heading) heading.textContent = next.dataset.collectionTitle;
   if (push) history.pushState({gnomeCatalog: true}, '', target);
   next.querySelector('.gn-count')?.focus({preventScroll:true});
   next.scrollIntoView({block:'start', behavior:'instant'});
  } catch (error) {
   if (error.name !== 'AbortError') location.assign(target);
  }
 }
 document.addEventListener('click', event => {
  const link = event.target.closest('[data-gn-catalog] a[data-gn-link], [data-gn-catalog] .gn-pagination a');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  navigate(link.href);
 });
 function submit(form) {
  const url = new URL(form.action, location.href);
  url.search = '';
  for (const [key, value] of new FormData(form)) if (value !== '') url.searchParams.append(key, value);
  navigate(url);
 }
 document.addEventListener('submit', event => {
  if (!event.target.matches('.gn-catalog-form')) return;
  event.preventDefault();
  submit(event.target);
 });
 document.addEventListener('change', event => {
  if (event.target.matches('[data-gn-sort]')) submit(event.target.form);
 });
 window.addEventListener('popstate', () => {
  if (document.querySelector('[data-gn-catalog]')) navigate(location.href, false);
 });
})();
